import { render } from "./LicenseList.vue?vue&type=template&id=ec4043ac"
import script from "./LicenseList.vue?vue&type=script&lang=js"
export * from "./LicenseList.vue?vue&type=script&lang=js"
script.render = render

export default script